import { render } from "./DropDownInfo.vue?vue&type=template&id=63390eb0&scoped=true"
import script from "./DropDownInfo.vue?vue&type=script&lang=js"
export * from "./DropDownInfo.vue?vue&type=script&lang=js"

import "./DropDownInfo.vue?vue&type=style&index=0&id=63390eb0&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\demo\\codebase 8x8\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63390eb0"]])

export default __exports__